import { ExtBase, ForeignKey } from "../../../core/db/models";
import Order from "./order";
import { Manufacturer, ManufacturerParcelType } from "./index";
import ValtasiirtoDatabase from "../index";
import OrderItemAssignment, { OrderItemAssignmentLike } from "./orderItemAssignment";
import OrderAssignment from "./orderAssignment";


export interface OrderItemLike extends ExtBase
{
    state: string;
    order_id: ForeignKey<Order>;
    manufacturer_id: ForeignKey<Manufacturer>;
    parcel_type_id: ForeignKey<ManufacturerParcelType>;
    quantity: number;

    order?: Order;
    manufacturer?: Manufacturer;
    parcel_type?: ManufacturerParcelType;
    assignments?: OrderItemAssignmentLike[];
}

export default class OrderItem implements OrderItemLike
{
    state: string;
    order_id: ForeignKey<Order>;
    manufacturer_id: ForeignKey<Manufacturer>;
    parcel_type_id: ForeignKey<ManufacturerParcelType>;
    quantity: number;
    order?: Order;
    manufacturer?: Manufacturer;
    parcel_type?: ManufacturerParcelType;
    assignments?: OrderItemAssignmentLike[];
    ext_id?: string;
    created_at?: string;
    modified_at?: string;
    id?: number;

    public static STATE_NEW = 'new';
    public static STATE_STARTED = 'started';
    public static STATE_COMPLETED = 'completed';

    public static withAll(db: ValtasiirtoDatabase, targetOrderItems: OrderItemLike[] | Dexie.Collection<OrderItem, any>): PromiseLike<OrderItemLike[]>
    {
        let orderItems: OrderItemLike[];

        return new Promise<OrderItemLike[]>((resolve, reject) =>
        {
            if (Array.isArray(targetOrderItems))
            {
                return resolve(targetOrderItems);
            }
            else
            {
                return targetOrderItems.toArray().then(resolve);
            }
        }).then((orderItemList) =>
        {
            orderItems = orderItemList;
            
            let orderItemIds = orderItems.map(o => o.id) as number[];
            let manufacturerIds = orderItems.map(o => o.manufacturer_id) as number[];
            let parcelTypeIds = orderItems.map(o => o.parcel_type_id) as number[];
            
            return Promise.all([
                db.Manufacturer.where('id').anyOf(manufacturerIds).toArray(),
                db.ManufacturerParcelType.where('id').anyOf(parcelTypeIds).toArray(),
                db.OrderItemAssignment.where('order_item_id').anyOf(orderItemIds).toArray(),
            ]);
        }).then((results) =>
        {
            let manufacturers = results[0];
            let parcelTypes = results[1];
            let assignments = results[2];

            for(let orderItem of orderItems)
            {
                orderItem.manufacturer = manufacturers.find(o => o.id == orderItem.manufacturer_id);
                orderItem.parcel_type = parcelTypes.find(o => o.id == orderItem.parcel_type_id);
                orderItem.assignments = assignments.filter(o => o.order_item_id == orderItem.id);
            }
            
            return OrderItemAssignment.withAll(db, assignments);
        }).then(() =>
        {
            return orderItems;
        })
    }
}